/**
 * Download all original uploaded documents for a denial case as a single zip.
 *
 * Used by both the /denials list and the dashboard queue tabs. The backend
 * route is GET /api/denials/:caseId/documents/download and responds with a
 * zip (or 404 when the case has no uploaded documents).
 */
import { dmClient } from '../../services/dmClient';

function pickFilename(headers, externalId, caseId, fallback) {
  const cd = headers && (headers['content-disposition'] || headers['Content-Disposition']);
  if (cd && typeof cd === 'string') {
    const match = /filename="?([^";]+)"?/i.exec(cd);
    if (match && match[1]) return match[1];
  }
  if (externalId) return `case-${externalId}-documents.zip`;
  if (caseId) return `case-${caseId}-documents.zip`;
  return fallback;
}

export async function downloadCaseDocuments(caseId, { externalId } = {}) {
  if (!caseId) throw new Error('caseId is required');
  const resp = await dmClient.get(`/denials/${caseId}/documents/download`, {
    responseType: 'blob',
  });
  const blob = resp.data instanceof Blob
    ? resp.data
    : new Blob([resp.data], { type: 'application/zip' });
  const filename = pickFilename(resp.headers, externalId, caseId, 'case-documents.zip');
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
  return filename;
}

export default downloadCaseDocuments;
